import { render } from "./EconomicsReview.vue?vue&type=template&id=4a721c67&scoped=true"
import script from "./EconomicsReview.vue?vue&type=script&lang=js"
export * from "./EconomicsReview.vue?vue&type=script&lang=js"

import "./EconomicsReview.vue?vue&type=style&index=0&id=4a721c67&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a721c67"]])

export default __exports__